import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("g", {
        clipPath: "url(#n4vjrt6re__clip0_1_4593)",
        children: _jsxs("g", {
          clipPath: "url(#vrx9xrvvk__clip1_1_4593)",
          children: [_jsx("path", {
            d: "M-33.3333 -5H20V25H-33.3333V-5Z",
            fill: "white"
          }), _jsx("path", {
            d: "M-33.3333 -5H20V10H-33.3333V-5Z",
            fill: "#FF0000"
          })]
        })
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "n4vjrt6re__clip0_1_4593",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "vrx9xrvvk__clip1_1_4593",
          children: _jsx("rect", {
            width: "53.3333",
            height: "30",
            fill: "white",
            transform: "translate(-33.3333 -5)"
          })
        })]
      })]
    }))
  });
};
export default Component;
